var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "el-dialog",
        {
          staticClass: "bj-dialog-list",
          class: _vm.classID,
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": true,
            title: _vm.vm.$t(_vm.config.title),
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            width: _vm.width,
            "append-to-body": "",
            "custom-class": _vm.customClass,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 - _vm.rightSpan } },
                [
                  _c(
                    "BjPage",
                    {
                      ref: "BjPage",
                      attrs: {
                        "query-params": _vm.queryParams,
                        "search-btn-span": _vm.searchBtnSpan,
                        "right-toolbar-hide": true,
                        "reset-btn-hide": _vm.resetBtnHide,
                        selection: _vm.multiple && _vm.multiple !== null,
                        radio: !_vm.multiple && _vm.multiple !== null,
                        disabled: _vm.disabled,
                        "col-span": _vm.colSpan,
                        "get-action": _vm.config.actionApi,
                        "auto-fetch": false,
                        "auto-scroll": _vm.autoScroll,
                        serial: _vm.serial,
                        stripe: false,
                        "row-key": _vm.rowKey,
                        "row-keys": _vm.rowKeys,
                        "row-style": _vm.rowStyleFun,
                        "cell-class-name": _vm.cellClassName,
                        "tag-name": _vm.tagName,
                        "show-tags": _vm.showTags,
                        "tag-x": _vm.tagX,
                        "is-list": _vm.isList,
                        height: _vm.maxHeight,
                        "tree-select-auto-parent": "",
                        "search-btn-hide": _vm.searchBtnHide,
                        "reset-data": _vm.resetData,
                        "before-reset-search": _vm.beforeResetSearch,
                        "check-method": _vm.checkMethod,
                        lazy: _vm.cptLazy,
                        load: _vm.load,
                        res: _vm.res,
                      },
                      on: {
                        handleSelectionChange: _vm.handleSelectionChange,
                        afterFetchData: _vm.afterFetchData,
                        afterFetchOriginalData: _vm.afterFetchOriginalData,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "baseForm",
                            fn: function () {
                              return [
                                _vm._l(
                                  _vm.config.search,
                                  function (searchJson, i) {
                                    return _c(
                                      "el-col",
                                      {
                                        key: i,
                                        attrs: {
                                          span: searchJson.multiple
                                            ? _vm.colSpan * 2
                                            : _vm.colSpan,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              "label-width": "0",
                                              prop: searchJson.key,
                                            },
                                          },
                                          [
                                            _c(
                                              searchJson.component || "BjInput",
                                              {
                                                tag: "component",
                                                staticClass: "search-input",
                                                attrs: {
                                                  multiple: searchJson.multiple,
                                                  disabled: searchJson.disabled,
                                                  placeholder: _vm.vm.$t(
                                                    searchJson.placeholder
                                                  ),
                                                  "suffix-icon":
                                                    "el-icon-search",
                                                  size: "mini",
                                                  "lov-code":
                                                    searchJson.lovCode,
                                                  "option-list":
                                                    searchJson.optionList,
                                                  "constant-key":
                                                    searchJson.constantKey,
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryParams[
                                                      searchJson.key
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryParams,
                                                      searchJson.key,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryParams[searchJson.key]",
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm.config.showChannelStore
                                  ? [
                                      _c("BjSelectChannelStore", {
                                        attrs: {
                                          span: _vm.colSpan,
                                          "label-width": ["0", "0"],
                                          "query-params": _vm.queryParams,
                                          "query-props": Array.isArray(
                                            _vm.config.showChannelStore
                                          )
                                            ? _vm.config.showChannelStore
                                            : [
                                                "channelTypeCode",
                                                "storeIdList",
                                              ],
                                          multiple: "",
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "tableTop",
                            fn: function () {
                              return [_vm._t("tableTop")]
                            },
                            proxy: true,
                          },
                          {
                            key: "tableColumn",
                            fn: function () {
                              return [
                                _vm._l(
                                  _vm.config.columns,
                                  function (column, i) {
                                    return [
                                      _c("el-table-column", {
                                        key: i,
                                        attrs: {
                                          prop: column.prop,
                                          label: _vm.vm.$t(column.label),
                                          "min-width": column.width || "180",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  column.constantKey
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.vm.$t(
                                                              _vm.constants[
                                                                column
                                                                  .constantKey
                                                              ].bjGet(
                                                                scope.row[
                                                                  column.prop
                                                                ]
                                                              )
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    : column.prop ==
                                                      "creationDate"
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "timeOperateTwoHour"
                                                            )(
                                                              scope.row[
                                                                column.prop
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    : column.prop == "cusId"
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.customerList.bjGet(
                                                              scope.row[
                                                                column.prop
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    : column.after
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[
                                                              column.prop
                                                            ]
                                                          ) +
                                                            _vm._s(column.after)
                                                        ),
                                                      ]
                                                    : column.array
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            (
                                                              scope.row[
                                                                column.prop
                                                              ] || []
                                                            )
                                                              .map(function (
                                                                e
                                                              ) {
                                                                return e[
                                                                  column.array
                                                                ] === undefined
                                                                  ? e
                                                                  : e[
                                                                      column
                                                                        .array
                                                                    ]
                                                              })
                                                              .join(",")
                                                          ) + " "
                                                        ),
                                                      ]
                                                    : column.prop ===
                                                      "totalOrderStatus"
                                                    ? [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type:
                                                                scope.row[
                                                                  column.prop
                                                                ] === 1
                                                                  ? "success"
                                                                  : "info",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm.ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(
                                                                    scope.row[
                                                                      column
                                                                        .prop
                                                                    ]
                                                                  )
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : column.prop
                                                        .toLocaleLowerCase()
                                                        .includes("amount") ||
                                                      column.prop
                                                        .toLocaleLowerCase()
                                                        .includes("price") ||
                                                      column.prop
                                                        .toLocaleLowerCase()
                                                        .includes("discount")
                                                    ? [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$number2money(
                                                                scope.row[
                                                                  column.prop
                                                                ]
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    : column.prop
                                                        .toLocaleLowerCase()
                                                        .includes("mobile") ||
                                                      column.prop
                                                        .toLocaleLowerCase()
                                                        .includes("phone")
                                                    ? [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "phoneFilter"
                                                              )(
                                                                scope.row[
                                                                  column.prop
                                                                ]
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row[
                                                                column.prop
                                                              ]
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ]
                                  }
                                ),
                                _vm._t("tableColumn"),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "paginationLeft" },
                        [_vm._t("paginationLeft")],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.rightSpan
                ? _c(
                    "el-col",
                    {
                      style: "height:" + _vm.maxHeight,
                      attrs: { span: _vm.rightSpan },
                    },
                    [
                      _vm._t("right", null, {
                        tags: _vm.tags,
                        selectedRows: _vm.selectedRows,
                        pagesSelectedRows: _vm.pagesSelectedRows,
                        maxHeight: _vm.maxHeight,
                        visible: _vm.visible,
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }